export default Object.freeze({
  Domestic: ['1', '2', '3', '8', 'P'],
  International: ['4', '4A', '5'],
  VisaRequired: ['2', '3', '4', '4A', '8', 'P']
})
